export default __webpack_public_path__ + "bc7ff595e734277fac5cc09f64af84b0.png";